import { useState, useEffect, useRef } from "react";
import {
	Label,
	Legend,
	Line,
	LineChart,
	Pie,
	PieChart,
	ReferenceArea,
	ReferenceLine,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { numberFormatter } from "../../../utils";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink } from "react-csv";
import TableTitle from "../../../components/common/Table/TableTitle";

const SupplierPareto = (props: any) => {
	const chartData = props.data.coordinates;
	const ref = props.refArea;
	const tableData = props.data;

	const [supplierExportData, setSupplierExportData] = useState<any>([]);

	const exportData = () => {
		let finalData: {
			MasterVendorName: any;
			gmValue: any;
			grossMargin: any;
			grossCost: any;
			marginGroup: any;
			l1: any;
			l2: any;
			l3: any;
		}[] = [];
		// finalData.push({ MasterVendorName: " 0 - 14% Gross Margin", gmValue: " " });

		chartData.map((item: any, i: number) => {
			if (item.gmValue * 100 <= 14) {
				finalData.push({
					MasterVendorName: item.MasterVendorName,
					gmValue: `${numberFormatter(item.gmValue * 100, 2)}%`,
					grossMargin: item.grossMargin,
					grossCost: item.grossCost,
					marginGroup: "0 - 14% Gross Margin",
					l1: item.l1,
					l2: item.l2,
					l3: item.l3,
				});
			}
		});

		// finalData.push({ MasterVendorName: `14 - ${tableData.gmPercentValue}% Gross Margin`, gmValue: " " });

		chartData.map((item: any, i: number) => {
			if (
				item.gmValue * 100 > 14 &&
				item.gmValue * 100 <= tableData.gmPercentValue
			) {
				finalData.push({
					MasterVendorName: item.MasterVendorName,
					gmValue: `${numberFormatter(item.gmValue * 100, 2)}%`,
					grossMargin: item.grossMargin,
					grossCost: item.grossCost,
					marginGroup: `14 - ${tableData.gmPercentValue}% Gross Margin`,
					l1: item.l1,
					l2: item.l2,
					l3: item.l3,
				});
			}
		});

		// finalData.push({ MasterVendorName: `${tableData.gmPercentValue} - ${tableData.gmPercentValue + 5}% Gross Margin`, gmValue: " " });

		chartData.map((item: any, i: number) => {
			if (
				item.gmValue * 100 > tableData.gmPercentValue &&
				item.gmValue * 100 <= tableData.gmPercentValue + 5
			) {
				finalData.push({
					MasterVendorName: item.MasterVendorName,
					gmValue: `${numberFormatter(item.gmValue * 100, 2)}%`,
					grossMargin: item.grossMargin,
					grossCost: item.grossCost,
					marginGroup: `${tableData.gmPercentValue} - ${
						tableData.gmPercentValue + 5
					}% Gross Margin`,
					l1: item.l1,
					l2: item.l2,
					l3: item.l3,
				});
			}
		});

		// finalData.push({ MasterVendorName: `${tableData.gmPercentValue + 5}%+ Gross Margin`, gmValue: " " });

		chartData.map((item: any, i: number) => {
			if (item.gmValue * 100 > tableData.gmPercentValue + 5) {
				finalData.push({
					MasterVendorName: item.MasterVendorName,
					gmValue: `${numberFormatter(item.gmValue * 100, 2)}%`,
					grossMargin: item.grossMargin,
					grossCost: item.grossCost,
					marginGroup: `${
						tableData.gmPercentValue + 5
					}%+ Gross Margin`,
					l1: item.l1,
					l2: item.l2,
					l3: item.l3,
				});
			}
		});

		finalData.sort((x: any, y: any) => y.grossMargin - x.grossMargin);

		finalData.map((item: any) => {
			item.grossMargin = `$${item.grossMargin.toFixed(0)}`;
			item.grossCost = `$${item.grossCost.toFixed(0)}`;
		});

		setSupplierExportData(finalData);
	};

	const exportFullRef = useRef<any>(null);

	const csvHeaders = [
		{ label: "L1", key: "l1" },
		{ label: "L2", key: "l2" },
		{ label: "L3", key: "l3" },
		{ label: "Vendor Name", key: "MasterVendorName" },
		{ label: "GM%", key: "gmValue" },
		{ label: "Gross Margin ($)", key: "grossMargin" },
		{ label: "Spend", key: "grossCost" },
		{ label: "Margin Group", key: "marginGroup" },
	];

	useEffect(() => {
		if (supplierExportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [supplierExportData]);

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				cursor: "pointer",
				color: "black",
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">
							Cumulative Margin:
						</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{numberFormatter(data.cumilativeMargin, 0, "$")}
						</div>
					</div>
					{/* Data Row */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								# Supplier:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{data.supplierNo}
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	const renderContent = (props: any) => {
		const { x, y, width, value, name } = props.viewBox;
		let totalCount = chartData[chartData.length - 1].supplierNo;
		let percent = Math.round((ref.supplierNo / totalCount) * 100);
		const lines = [
			"80% of the margin ",
			`comes from ${ref.supplierNo}`,
			`suppliers`,
		];
		return (
			<text
				fill="#9acd32b8"
				x={x}
				y={y}
				fontSize={14}
				fontStyle={"italic"}
			>
				{lines.map((line: any, index: any) => (
					<tspan key={index} x={1.5 * x} dy={index === 0 ? 30 : 20}>
						{line}
					</tspan>
				))}
			</text>
		);
	};

	return (
		<div className="h-full w-full flex flex-col">
			<div className="headSpace">
				<div className="headContent">
					# of Suppliers by Cumulative Margin (Sorted by Margin %)
				</div>
				<FileDownloadIcon
					className="mr-[2vh] cursor-pointer "
					style={{ background: "#9acd32b8", borderRadius: ".3vh" }}
					onClick={() => {
						exportData();
					}}
				/>
				<CSVLink
					ref={exportFullRef}
					data={supplierExportData}
					headers={csvHeaders}
					filename="supplierPareto.csv"
					className="hidden"
					target="_blank"
				>
					{" "}
				</CSVLink>
			</div>
			<div className="grow w-full h-[55%]">
				<ResponsiveContainer width="100%" height="100%">
					<LineChart
						data={chartData}
						margin={{ left: 20, right: 20 }}
					>
						<XAxis
							className="graph-label"
							dataKey="supplierNo"
							type="number"
							domain={[0, "dataMax"]}
						/>
						<YAxis
							className="graph-label "
							tickFormatter={(value: number) =>
								numberFormatter(value, 0)
							}
						>
							<Label
								className="graph-label"
								value="Margin ($)"
								angle={-90}
								position="insideLeft"
								style={{ fill: "#000", textAnchor: "middle" }}
							/>
						</YAxis>
						<Tooltip
							contentStyle={{
								color: "black",
								backgroundColor: "rgb(26, 25, 22)",
							}}
							cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
							content={customTooltip}
						/>
						<ReferenceArea
							x1={0}
							x2={ref.supplierNo}
							y1={0}
							y2={ref.cumilativeMargin}
							stroke="#e3e48d"
							strokeOpacity={0.4}
							fill="#e3e48d"
							fillOpacity={0.4}
						>
							<Label
								content={(obj: any) => renderContent(obj)}
								stroke="black"
								position="right"
								style={{ fill: "black" }}
							/>
						</ReferenceArea>
						<Line
							dataKey="cumilativeMargin"
							stroke="#9acd32b8"
							dot={false}
							strokeWidth={3}
						/>
					</LineChart>
				</ResponsiveContainer>
			</div>
			<div className="grow w-full h-[35%]">
				<table className="common-table-ui">
					<thead>
						<tr>
							<th className="w-[50vw]">Supplier category</th>
							<th className="w-[50vw]"># Suppliers</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>0 - 14% Gross Margin</td>
							<td>
								{numberFormatter(
									tableData.CountOfSuppliersGM1,
									0
								)}
							</td>
						</tr>
						<tr>
							<td>
								14 - {tableData.gmPercentValue}% Gross Margin
							</td>
							<td>
								{numberFormatter(
									tableData.CountOfSuppliersGM2,
									0
								)}
							</td>
						</tr>
						<tr>
							<td>
								{tableData.gmPercentValue} -{" "}
								{tableData.gmPercentValue + 5}% Gross Margin
							</td>
							<td>
								{numberFormatter(
									tableData.CountOfSuppliersGM3,
									0
								)}
							</td>
						</tr>
						<tr>
							<td>
								{tableData.gmPercentValue + 5}%+ Gross Margin
							</td>
							<td>
								{numberFormatter(
									tableData.CountOfSuppliersGM4,
									0
								)}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default SupplierPareto;
